import { computed } from 'vue'
import { useNuxtApp } from '#app/nuxt'

const useExperiments = () => {
  const { $experiments } = useNuxtApp()
  const { isActive } = $experiments

  return {
    showOdoscopePlp: computed(() => isActive('experiment-plp', 'odoscope-plp')),
    showCheckoutPageNewLayout: computed(() => true),
    showPdpFoldableColors: computed(() =>
      isActive('experiment-pdp-foldable-colors', 'new'),
    ),
    showNewGallery: computed(() => isActive('experiment-pdp-gallery', 'new')),
    showNewDesktopPlpQuickFilters: computed(() => true),
    loadLeapScript: computed(() => isActive('experiment-leap-script', 'new')),
    // Rolled out on production goldner-fashion.de; experiment registry isn't
    // returning the 'new' variant on the preview/preprod tier, so the CMS
    // GoldnerClubLink entry never renders. Hardcode until the legacy
    // experiment record is removed.
    showGoldnerClub: computed(() => true),
    showChooseOneSizeModal: computed(() =>
      isActive('experiment-choose-one-size', 'new'),
    ),
    showPerformanceModule: computed(() =>
      isActive('experiment-performance-module', 'variant'),
    ),
    showReducedRecosSpacing: computed(() =>
      isActive('experiment-recos-spacing', 'new'),
    ),
  }
}

export default useExperiments
